<div class="layout-margin">
  <form fxLayout="column" [formGroup]="templateForm">
    <mat-form-field fxFlex>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
    </mat-form-field>
    <pr-content-editor
      formControlName="content"
      [required]="true"
      [menuEnabled]="true"
      [defaultFont]="(documentSettings$ | async)?.fontFamily"
      [defaultLineHeight]="(documentSettings$ | async)?.lineHeight"
      [defaultParagraphSpacing]="(documentSettings$ | async)?.paragraphSpacing"
    />
  </form>
  <pt-buttons-container>
    <button mat-stroked-button color="warn" (click)="delete()">Delete</button>
    <pt-loader-button-with-menu
      label="Print"
      type="flat"
      color="primary"
      loadingLabel="Building Document"
      [loading]="pdfService.generatingPdf()"
      (buttonClick)="print()"
    >
      <button type="button" mat-menu-item (click)="printSettings()">
        <mat-icon>tune</mat-icon>
        Print Settings
      </button>
      <button mat-menu-item (click)="generatePdf()">
        <mat-icon>picture_as_pdf</mat-icon>
        Generate PDF
      </button>
    </pt-loader-button-with-menu>
  </pt-buttons-container>
</div>
